export enum DateIntervalType {
  Default = 'Default',
  OneDay = 'OneDay',
  OneWeek = 'OneWeek',
  OneMonth = 'OneMonth',
  ThreeMonths = 'ThreeMonths',
  SixMonths = 'SixMonths',
  TwelveMonths = 'TwelveMonths',
  ThisYear = 'ThisYear'
}
